<template>
    <div class="main-body">
        <div class="header">物品出入库记录</div>
        <div class="out">
            <div class="search2">

              <download-excel
                  class = "export-excel-wrapper"
                  :fetch           = "fetchData"
                  :fields          = "json_fields"
                  :before-generate = "startDownload"
                  :before-finish   = "finishDownload"
                  name = "物品出入库记录.xls"
                  style="display: inline-block;">
                <el-button type="success" plain size="mini">导出</el-button>
              </download-excel>

                <div style="clear: both;"></div>
            </div>


            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th"
                      border highlight-current-row>

                <el-table-column prop="stockinRemarks" label="入库备注"></el-table-column>
                <el-table-column prop="stockinCreateTime" label="入库时间" :formatter="timefilter"></el-table-column>
              <el-table-column prop="waresName" label="物品名称"></el-table-column>
              <el-table-column prop="stockinWaresCount" label="入库数量"></el-table-column>
              <el-table-column prop="stockinWaresExpiresTime" label="过期时间" :formatter="timefilter"></el-table-column>
              <el-table-column prop="stockoutCreateTime" label="出库时间" :formatter="timefilter"></el-table-column>
              <el-table-column prop="stockoutWaresCount" label="出库数量"></el-table-column>
              <el-table-column prop="waresCountNow" label="当前库存"></el-table-column>


            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

      <div v-if="showModal" class="mask">
        <div class="lodingsIcon">
          <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
        </div>
      </div>

    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,


              showModal:false,
              json_fields: {

                "入库备注": "stockinRemarks",
                "入库时间": {
                  field:"stockinCreateTime",
                  callback:value=>{
                    return timefilters(value);
                  }
                },
                "物品名称": "waresName",
                "入库数量": "stockinWaresCount",
                "过期时间": {
                  filed:"stockinWaresExpiresTime",
                  callback:value=>{
                    return timefilters(value);
                  }
                },
                "出库时间": {
                  field:"stockoutCreateTime",
                  callback:value=>{
                    return timefilters(value);
                  }
                },
                "出库数量": "stockoutWaresCount",
                "当前库存": "waresCountNow",


              },

            }
        },
        components:{

        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{


            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Stockout/InOutInsPage",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfo.list;
                        this.totalItems = response.data.data.pageInfo.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

          timefilter(row, column, cellValue) {
            if (cellValue) {
              return timefilters(cellValue)
            }
          },


          async fetchData(){

            let data={
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              staffCode: getStaffCode(),
              pageIndex:1,
              pageSize:99999,
            }

            const response = await this.$axios.post(this.$shopUrl + "Stockout/InOutInsPage",data);
            return response.data.data.pageInfo.list;
          },
          startDownload:function (){
            this.showModal = true;
          },
          finishDownload:function (){
            this.showModal = false;
          },




        }
    }
</script>

<style lang='scss' scoped>

/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }

</style>
